import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import "./ShopByBrand.css";

const BASE_URL = "https://madhusewingmachines.com/api/brands";

// Framer motion variants
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const ShopByBrands = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(BASE_URL);
        setBrands(response.data.brands);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching brands:", error);
        setError("Failed to load brands.");
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  const handleCardClick = (brandName) => {
    navigate("/productpage", {
      state: { brandFilter: brandName }
    });
  };

  const pageStyle = { backgroundColor: "#EFFBFF" };

  if (loading) {
    return (
      <div style={pageStyle}>
        <Container className="py-5 text-center">
          <p>Loading brands...</p>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div style={pageStyle}>
        <Container className="py-5 text-center">
          <p className="text-danger">{error}</p>
        </Container>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <Container className="py-5 text-center">
        {/* Animated Heading */}
        <motion.h2
          className="fw-bold mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
      style={{
  color: "#000", // Pure black
}}
        >
          🛍️ Choose by Brand 🛍️
        </motion.h2>

        {/* Animated Cards with Stagger */}
        <motion.div variants={containerVariants} initial="hidden" animate="show">
          <div className="brand-scroll">
            {brands.map((brand) => (
              <div key={brand._id} className="brand-item">
                <motion.div variants={cardVariants} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
                  <Card
                    className="d-flex align-items-center justify-content-center p-3 shadow-sm rounded-4"
                    style={{
                      height: "120px",
                      cursor: "pointer",
                      backgroundColor: "#FADBD8",
                      transition: "transform 0.3s ease-in-out",
                    }}
                    onClick={() => handleCardClick(brand.name)}
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-circle bg-white shadow-sm"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <img
                          src={`https://madhusewingmachines.com/uploads/${brand.logo}`}
                          alt={brand.name}
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div className="ms-3 text-start">
                        <h5 className="fw-bold m-0">{brand.name}</h5>
                        <p className="m-0" style={{ fontSize: "0.9rem" }}>
                          🚚 Deliver in 24 hours
                        </p>
                      </div>
                    </div>
                  </Card>
                </motion.div>
              </div>
            ))}
          </div>
        </motion.div>
      </Container>
    </div>
  );
};

export default ShopByBrands;
